var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7651 10.5487L10.8996 5.41421C11.0871 5.22668 11.1925 4.97232 11.1925 4.70711C11.1925 4.15482 10.7447 3.70711 10.1925 3.70711C9.92724 3.70711 9.67289 3.81246 9.48535 4L4.35089 9.13447C4.19888 9.28647 4.07238 9.46198 3.97624 9.65425L3.24383 11.1191C3.07192 11.4629 3.43667 11.8276 3.78049 11.6557L5.24531 10.9233C5.43758 10.8272 5.6131 10.7007 5.7651 10.5487Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H11H11.25C11.6642 12 12 11.6642 12 11.25C12 10.8358 11.6642 10.5 11.25 10.5H10.75C10.3358 10.5 10 10.1642 10 9.75C10 9.33579 10.3358 9 10.75 9H13",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/Signature.5c79fca81b0d462d3a9f301bcd489f05.svg";
export { ForwardRef as ReactComponent };